import React, { useState } from 'react'
import { SignInForm } from '../components/Auth/SignInForm'
import { SignUpForm } from '../components/Auth/SignUpForm'
import { Shield } from 'lucide-react'

interface AuthProps {
  onNavigateToTerms?: () => void
  onNavigateToPrivacy?: () => void
  onBack?: () => void
  defaultToSignUp?: boolean
}

export const Auth: React.FC<AuthProps> = ({ onNavigateToTerms, onNavigateToPrivacy, onBack, defaultToSignUp = false }) => {
  const [isSignUp, setIsSignUp] = useState(defaultToSignUp)

  return (
    <div className="min-h-screen bg-gradient-to-br from-dark-primary via-dark-secondary to-dark-tertiary flex items-center justify-center p-4">
      {/* Background effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-to-br from-primary-600/10 to-transparent rounded-full blur-3xl" />
        <div className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-to-tl from-primary-500/10 to-transparent rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 w-full max-w-md">
        {/* Back Button */}
        {onBack && (
          <button
            onClick={onBack}
            className="absolute -top-4 -left-4 p-2 text-light-secondary hover:text-light-primary transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
        
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-primary-600 to-primary-500 rounded-2xl mb-4 shadow-lg">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-light-primary mb-2">
            BLP Assistant
          </h1>
          <p className="text-light-tertiary">
            Professional support for Beneficiary Liquidity Plan sales
          </p>
        </div>

        {/* Auth Forms */}
        {isSignUp ? (
          <SignUpForm onSwitchToSignIn={() => setIsSignUp(false)} />
        ) : (
          <SignInForm onSwitchToSignUp={() => setIsSignUp(true)} />
        )}

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-xs text-light-tertiary mb-2">
            By signing in, you agree to our{' '}
            <button
              onClick={onNavigateToTerms}
              className="text-primary-400 hover:text-primary-300 underline transition-colors duration-200 focus:outline-none focus:ring-1 focus:ring-primary-500/50 rounded"
            >
              Terms of Service
            </button>
            {' '}and{' '}
            <button
              onClick={onNavigateToPrivacy}
              className="text-primary-400 hover:text-primary-300 underline transition-colors duration-200 focus:outline-none focus:ring-1 focus:ring-primary-500/50 rounded"
            >
              Privacy Policy
            </button>
          </p>
          <div className="text-xs text-light-tertiary/70 space-y-1">
            <p>© 2024 Listening Glass, LLC. All rights reserved.</p>
            <p>The Beneficiary Liquidity Plan (BLP) is a registered trademark and used with permission of Phil Graham, creator of the BLP.</p>
          </div>
        </div>
      </div>
    </div>
  )
}